import React, { useEffect, useState } from "react";
import "./headerHora.scss";

export default function HeaderHora() {
  const [agora, setAgora] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setAgora(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const dataFormatada = agora.toLocaleDateString("pt-BR");
  const horaFormatada = agora.toLocaleTimeString("pt-BR");

  return (
    <div className="header-hora">
      {dataFormatada} às {horaFormatada} | v2.3.0
    </div>
  );
}
